import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Subscription } from 'rxjs';

import { ISrCancellationDetails } from 'src/app/model/common.model';
import { ServiceRequestService } from 'src/app/service/service-request.service';

@Component({
  selector: 'app-reason-display-dialog',
  templateUrl: './reason-display-dialog.component.html',
  styleUrls: ['./reason-display-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReasonDisplayDialogComponent implements OnInit, OnDestroy {
  loader = false;
  reasonDetails: ISrCancellationDetails;
  private subscriptions: Subscription[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public sRCancellationReasonId: string,
    public dialogRef: MatDialogRef<ReasonDisplayDialogComponent>,
    private _serviceRequestService: ServiceRequestService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnInit(): void {
    this.fetchSRCancellationDetails();
  }

  private fetchSRCancellationDetails() {
    this.loader = true;
    const getSrCancellationDetailsSubs = this._serviceRequestService
      .getSrCancellationDetails(this.sRCancellationReasonId).subscribe(
        (response: ISrCancellationDetails) => {
          this.reasonDetails = response;
          this.loader = false;
          this.cdr.markForCheck();
        },
        () => {
          this.loader = false;
          this.cdr.markForCheck();
        }
      );
    this.subscriptions.push(getSrCancellationDetailsSubs);
  }
}
